module.exports = __webpack_public_path__ + "images/emoji/clock630.c0b3e0265090e96e1d60.png";